import React from "react";
import "../styles/secdevtool.css";
import PropTypes from 'prop-types'; // Import PropTypes
import ldlogo from "../assets/Lomnido_logo.png";
import "../assets/Homepage_Robot.png";

const Card = ({ title, description, link }) => {
  return (
    <div className="card rounded h-100 flip-card cardCss d-flex flex-column">
      <div className="card-body flip-card-inner shadow flex-grow-1 d-flex flex-column justify-content-between">
        <div className="flip-card-front">
          <h5 className="card-title fontLd text-light">{title}</h5>
          <p className="card-text fontLd text-light">{description}</p>
        </div>
        <div className="flip-card-back d-flex align-items-center justify-content-center">
          <div>
            <a href={link} className="probieren btn btn-outline border-bottom fontLd text-light">Try it out</a>
          </div>
        </div>
      </div>
    </div>
  );
};

// PropTypes validation for Card component props
Card.propTypes = {
  title: PropTypes.string.isRequired, // Validate 'title' prop as a required string
  description: PropTypes.string.isRequired, // Validate 'description' prop as a required string
  link: PropTypes.string.isRequired, // Validate 'link' prop as a required string
};

{/*
const CardGrid = () => {
  const cardData = [
      {
        title: "Base64 En/Decoder",
        description: "Use the Base64 encoding method to encode your data into readable ASCII characters",
        link: "/BASE64_EnDecode"
      },
      {
        title: "JSON Pretty Print",
        description: "Beautify your JSON data to make it more organized and appealing",
        link: "/JSON_Formatter"
      },
      {
        title: "URL En/Decode",
        description: "Decode encoded URLs or encode URLs with spaces or other special characters",
        link: "/URL_EnDecode"
      },
      {
        title: "Unix Timestamp",
        description: "Convert a Unix timestamp to a regular date and vice versa",
        link: "/Unix_Timestamp"
      },
      {
        title: "XML Formatter",
        description: "Format the XML string or file according to the desired indentation level",
        link: "/XML_Formatter"
      },
      {
        title: "Send Plain Text Email",
        description: "Send a Plain Text Email using the Secure Developer Tool",
        link: "/Send_Plain_Text_Email"
      }
  ];

  return (
    <div className="mt-5 row row-cols-1 row-cols-md-3 row-cols-sm-2 row-cols-xs-1 g-4 pb-5">
      {cardData.map((card, index) => (
        <div className="col" key={index}>
          <Card {...card} />
        </div>
      ))}
    </div>
  );
  
};
*/}

const Home = () => {
  return (
      <main role="main" className="container text-center">
          <h1 className="mt-5 mb-5 fontLd">Developer Tools</h1>
          <hr></hr>
          <div className="d-flex justify-content-center p-2">
              <pre className="mt-1">{">>"} Powered by </pre>
              <img src={ldlogo} className="ldlogo" alt="Lomnido Logo"></img>
          </div>
          <hr></hr>
          {/* Placeholder for CardGrid */}
          {/* <CardGrid /> */}
      </main>
  );
};

export default Home;